import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Pregunta } from '../../Ui/pregunta/Pregunta';
import { Preguntas } from '../../../helpers/Data.helper';
import classes from './Faq.module.css';

const Faq = () => {

  return (
    <>
    <Container>
      <Row>
        <Col className="title-container">
          <div>
            <h1>Preguntas Frecuentes</h1>
            <span>Estas son las preguntas más frecuentes de nuestra comunidad</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {
            Preguntas.map((item, index) => (
              <Pregunta data={item} key={item.id} />
            ))
          }
        </Col>
      </Row>
    </Container>
    <img alt='Footer' className={classes.footerImg} src="/images/footer-tecmilenio.png" width="100%" style={{marginTop: '70px'}}/>
    <img alt='Footer' className={classes.mobileFooterImg} src="/images/footer-tecmilenio-mobile.png" width="100%" style={{marginTop: '70px'}}/>
    </>
  );
}
export default Faq;
